export default "__VITE_ASSET__DanuXy4l__"